export default __webpack_public_path__ + "static/media/app_store.cd3544ba.svg";